<template>
  <!-- 취소·환불·시간 변경 규정 한 벌. 결제 직전 주의사항 창과 마이페이지 '환불 규정 다시보기'가 같은 글을 쓴다. -->
  <div class="policy-summary">
    <section class="policy-summary__section">
      <h3 class="policy-summary__heading">{{ $t("dialog.policy.cancel-title") }}</h3>
      <dl class="policy-summary__table">
        <div v-for="row in refundRows" :key="row.when" :class="{ 'policy-summary__row--none': !row.percent }">
          <dt>{{ $t(`dialog.policy.${row.when}`) }}</dt>
          <dd>{{ row.percent ? $t("dialog.policy.refund-percent", { percent: row.percent }) : $t("dialog.policy.refund-none") }}</dd>
        </div>
      </dl>
      <p class="policy-summary__note">{{ $t("dialog.policy.refund-24h") }}</p>
      <p class="policy-summary__note">{{ $t("dialog.policy.refund-strict") }}</p>
    </section>

    <section class="policy-summary__section">
      <h3 class="policy-summary__heading">{{ $t("dialog.policy.change-title") }}</h3>
      <dl class="policy-summary__table">
        <div>
          <dt>{{ $t("dialog.policy.change-when") }}</dt>
          <dd>{{ $t("dialog.policy.change-free") }}</dd>
        </div>
        <div class="policy-summary__row--none">
          <dt>{{ $t("dialog.policy.when-3") }}</dt>
          <dd>{{ $t("dialog.policy.change-none") }}</dd>
        </div>
      </dl>
      <p class="policy-summary__note">{{ $t("dialog.policy.change-same-day") }}</p>
      <p class="policy-summary__note">{{ $t("dialog.policy.change-limit") }}</p>
      <p class="policy-summary__note">{{ $t("dialog.policy.change-date") }}</p>
    </section>

    <section v-if="showVisitRule" class="policy-summary__section">
      <h3 class="policy-summary__heading">{{ $t("dialog.policy.visit-title") }}</h3>
      <ul class="policy-summary__list">
        <li>{{ $t("dialog.policy.visit-row-1") }}</li>
        <li>{{ $t("dialog.policy.visit-row-2") }}</li>
        <li>{{ $t("dialog.policy.visit-row-3") }}</li>
      </ul>
    </section>
  </div>
</template>

<script>
// 환불 비율은 서버 규칙(express/services/payments.js checkAmount)과 마이페이지 계산(getCanCancelAmount)과 같은 값이다.
const REFUND_ROWS = [
  { when: "when-7", percent: 100 },
  { when: "when-6", percent: 80 },
  { when: "when-5", percent: 50 },
  { when: "when-4", percent: 30 },
  { when: "when-3", percent: 0 },
]

export default {
  name: "ReservationPolicySummary",

  props: {
    // 프리미엄샷은 결제 직전 창이 한 쪽뿐이라, 지각·노쇼 규정을 이 요약에 함께 보여 준다.
    showVisitRule: { type: Boolean, default: false },
  },

  computed: {
    refundRows() {
      return REFUND_ROWS
    },
  },
}
</script>

<style scoped>
.policy-summary {
  display: grid;
  gap: 14px;
  width: 100%;
  margin-top: 12px;
  color: #433b3f;
  text-align: left;
  word-break: keep-all;
}

/* 일본어는 keep-all이면 줄이 바뀌지 않아 창 밖으로 넘친다. 되는 브라우저에서는 말 마디에서 줄을 바꾼다. */
.policy-summary:lang(ja) {
  word-break: normal;
  line-break: strict;
}

@supports (word-break: auto-phrase) {
  .policy-summary:lang(ja) {
    word-break: auto-phrase;
  }
}

.policy-summary__section {
  padding: 12px 14px;
  border: 1px solid #e4ddd9;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.64);
}

.policy-summary__heading {
  margin: 0 0 8px;
  color: #2f292d;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.policy-summary__table {
  display: grid;
  margin: 0;
}

.policy-summary__table > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) fit-content(55%);
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #efe9e5;
  font-size: 14px;
  line-height: 1.45;
}

.policy-summary__table dt {
  color: #5d5458;
}

.policy-summary__table dd {
  margin: 0;
  color: #2f292d;
  font-weight: 700;
  text-align: right;
}

.policy-summary__row--none dt,
.policy-summary__row--none dd {
  color: #a53a66;
}

.policy-summary__list {
  display: grid;
  gap: 4px;
  margin: 0;
  padding: 0 0 0 18px;
  font-size: 14px;
  line-height: 1.5;
}

/* ※ 줄: 둘째 줄부터는 글자 시작 자리에 맞춘다. */
.policy-summary__note {
  position: relative;
  margin: 8px 0 0;
  padding-left: 1.3em;
  color: #766d71;
  font-size: 13px;
  line-height: 1.5;
}

.policy-summary__note + .policy-summary__note {
  margin-top: 4px;
}

.policy-summary__note::before {
  position: absolute;
  left: 0;
  content: "※";
}

@media (min-width: 600px) {
  .policy-summary__table > div,
  .policy-summary__list {
    font-size: 15px;
  }
}
</style>
